import {styled} from '@linaria/react';
import React, {ReactNode} from 'react';

export interface MiniArticleDetailsLayoutProps {
  imageSlider: ReactNode;
  priceAndBrand: ReactNode;
  prominentBanner: ReactNode;
  productSelection: ReactNode;
  sizeSelection: ReactNode;
}

export const MiniArticleDetailsLayout: React.FC<
  MiniArticleDetailsLayoutProps
> = ({
  imageSlider,
  priceAndBrand,
  productSelection,
  sizeSelection,
  prominentBanner,
}) => {
  return (
    <Content>
      <Container>
        <Column data-testid="imageSliderLayout">{imageSlider}</Column>
        <Column data-testid="priceAndBrand_addToBasketSectionLayout">
          {priceAndBrand}
          {prominentBanner}
          <Row data-testid="productSelectionLayout">{productSelection}</Row>
          {sizeSelection}
        </Column>
      </Container>
    </Content>
  );
};

const Content = styled.div`
  display: flex;
  justify-content: space-between;
  position: relative;
  max-width: 680px;
`;

const Column = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  flex: 1;
  min-width: 200px;
  max-width: 50%;
  min-height: 490px; // to prevent flickering when the image thumbnails slider is loaded
`;

const Row = styled.div`
  padding-bottom: 1rem;
  padding-top: 1rem;
`;

const Container = styled.article`
  position: relative;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  gap: 2.5rem;
`;
